/**
 * CheckoutCancelPage — /checkout/cancel
 * Simple "no worries" screen shown when the user backs out of the Stripe
 * checkout page. The cart is preserved.
 */
import { Link } from "react-router-dom";
import { ShoppingBag, ArrowLeft } from "lucide-react";

export default function CheckoutCancelPage() {
  return (
    <div className="max-w-lg mx-auto px-4 py-16 text-center" data-testid="checkout-cancel-page">
      <ShoppingBag className="w-14 h-14 mx-auto opacity-40 mb-3" />
      <h1 className="font-display text-4xl mb-2">Checkout cancelled</h1>
      <p className="opacity-70 mb-6">Your cart is safe — pick up where you left off any time.</p>
      <div className="flex flex-wrap gap-2 justify-center">
        <Link to="/cart" className="wofy-btn-primary inline-flex items-center gap-1.5"><ArrowLeft className="w-4 h-4" /> Back to cart</Link>
        <Link to="/businesses" className="wofy-btn-ghost inline-flex">Keep exploring</Link>
      </div>
    </div>
  );
}
